import { _getBuyerSupportLink as getBuyerSupportLink } from '../src/getSupportLink.ts';

export default getBuyerSupportLink;
